export default function isValidNumberInput(value) {
  return !(
    value === "" ||
    value === null ||
    value === undefined ||
    Number.isNaN(value) ||
    value === Infinity
  );
}
